import React, { useEffect } from "react";

export const Buymeacoffee = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const div = document.getElementById("supportByBMC");
    const checkDiv = document.getElementById("bmc-loaded");
    const element = document.getElementById("bmc-wbtn");
    const newDiv = document.createElement("div");
    newDiv.id = "bmc-loaded";
    if (!element && !checkDiv) {
      div?.appendChild(newDiv);
      script.setAttribute("src", "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js");
      script.setAttribute("data-name", "BMC-Widget");
      script.setAttribute("data-cfasync", "false");
      script.setAttribute("data-id", "ik.takagishi");
      script.setAttribute("data-description", "Support me on Buy me a coffee!");
      script.setAttribute("data-message", "Thank you for visiting!");
      script.setAttribute("data-color", "#FD0");
      script.setAttribute("data-position", "Right");
      script.setAttribute("data-x_margin", "18");
      script.setAttribute("data-y_margin", "18");
      script.onload = function () {
        const evt = document.createEvent("Event");
        evt.initEvent("DOMContentLoaded", false, false);
        window.dispatchEvent(evt);
      };
    }
    div && !element && div.appendChild(script);
  }, []);

  return <div id="supportByBMC"></div>;
};
